import { execute } from '@lib/graphql/execute'
import { graphql } from '@lib/graphql/gql'
import { QueryConfig } from '@lib/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

const orderByIdQueryDocument = graphql(`
  query CheckoutOrderById($id: ID!) {
    order(id: $id) {
      id
      orderNumber
      createdAt
      total {
        centAmount
        currencyCode
        fractionDigits
      }
      subtotal {
        centAmount
        currencyCode
        fractionDigits
      }
      billingAddress {
        email
        phone
        address1
        address2
        city
        postalCode
        firstName
        lastName
        company
        state
        countryCode
        formatted
      }
      # shippingMethod {
      #   shippingMethodName
      #   unitPrice {
      #     centAmount
      #     currencyCode
      #     fractionDigits
      #   }
      # }
      shippingLines {
        shippingMethod {
          name
        }
        total {
          centAmount
          currencyCode
          fractionDigits
        }
      }

      shippingAddress {
        email
        phone
        address1
        address2
        city
        postalCode
        firstName
        lastName
        company
        state
        countryCode
        formatted
      }
      taxedPrice {
        gross {
          centAmount
          currencyCode
          fractionDigits
        }
        net {
          centAmount
          currencyCode
          fractionDigits
        }
        tax {
          centAmount
          currencyCode
          fractionDigits
        }
      }
      lineItems {
        edges {
          node {
            id
            quantity
            product {
              id
              name
              vendor
              tags
              metadata {
                key
                value
              }
            }
            discountApplications {
              edges {
                node {
                  discountedAmount {
                    centAmount
                    currencyCode
                  }
                }
              }
            }
            productSlug
            productName
            variantName
            sku
            variant {
              image {
                src
              }
            }

            unitPrice {
              value {
                ...Money
              }
              discountedPrice {
                value {
                  ...Money
                }
              }
            }
            subtotal {
              ...Money
            }

            total {
              ...Money
            }
            metadata {
              key
              value
            }
          }
        }
      }
    }
  }
`)

export const getCheckoutOrderById = (orderId: string) => {
  //This is used to make the query retry, if it fails
  return execute(orderByIdQueryDocument, { id: orderId }).then((x) =>
    x.order == null ? Promise.reject('Order not found') : x,
  )
}

export const getCheckoutOrderByIdQueryOptions = (psp: string) => {
  return queryOptions({
    queryKey: ['order', psp],
    queryFn: () => getCheckoutOrderById(psp),
    retry: 10,
  })
}

type UseOrderByPspOptions = {
  orderId: string
  queryConfig?: QueryConfig<typeof getCheckoutOrderByIdQueryOptions>
}

export const useCheckoutOrderById = ({
  queryConfig,
  orderId,
}: UseOrderByPspOptions) => {
  return useQuery({
    ...getCheckoutOrderByIdQueryOptions(orderId),
    ...queryConfig,
  })
}
